<template>
  <v-select
    dense
    v-model="selectediva"
    :items="itemsParaMostrar"
    :loading="loadingAlicuotas && itemsParaMostrar.length === 0"
    label="IVA"
    outlined
    item-text="description"
    item-value="description"
    return-object
    :disabled="!isEdit"
    hide-details
  ></v-select>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    iva: { type: Object, required: true },
    isEdit: { type: Boolean, default: false },
    // Prop opcional para recibir las alícuotas del padre
    options: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState('contabilidad', ['alicuotasIva', 'loadingAlicuotas']),
    
    // Decidimos qué mostrar: lo que viene por prop o lo que hay en el store
    itemsParaMostrar() {
      return this.options.length > 0 ? this.options : this.alicuotasIva;
    },

    selectediva: {
      get() { return this.iva },
      set(value) { this.$emit('update:iva', value) }
    }
  },
  methods: {
    ...mapActions('contabilidad', ['fetchAlicuotasIva'])
  },
  created() {
    // Si no recibimos nada por prop Y el store está vacío, hacemos el fetch
    if (this.options.length === 0 && this.alicuotasIva.length === 0) {
      this.fetchAlicuotasIva();
    }
  }
};
</script>